import { NotFoundPageNL } from "@pages/NotFoundPage/NotFoundPage"
import { useAppStructure } from "@redux/features/appStructure/useAppStructure"
import DashboardPageLayout from "@sop/DashboardPage/DashboardPageLayout"
import { createFileRoute } from "@tanstack/react-router"
import { LoadingCircle } from "@ui-lib/index"

export const ModulesList = [
	"operations",
	"vessel-status",
	"fleet-overview",
	"consumption",
	"machinery",
	"cbm",
	"voyage",
	"emission",
	"historical-data",
	"download-data",
	"seemp",
	"efficiency",
] as const

export type ModuleNameSOP = (typeof ModulesList)[number]

export const Route = createFileRoute("/clients/$clientName/_sopPageLayout")({
	component: RouteComponent,
})

function RouteComponent() {
	const { clientName } = Route.useParams()
	const { data: appStruct } = useAppStructure()
	if (appStruct == null) {
		return <LoadingCircle containerHeightWithUnit="100vh" />
	}

	const clientData = appStruct["Dipai"]?.clients?.[clientName as string]
	if (clientData === undefined) {
		return (
			<NotFoundPageNL
				linkTo={"/clients"}
				labelTo="Go back"
			/>
		)
	}
	return <DashboardPageLayout props={{ [clientName]: clientData }} />
}
